module.exports = __webpack_public_path__ + "static/media/edit.7cabe70f.svg";